"use strict";
// import { TranslateResult } from 'vue-i18n';
// import i18n from '../i18n';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Model_1 = __importDefault(require("../Model"));
var ListItemModel = /** @class */ (function (_super) {
    __extends(ListItemModel, _super);
    function ListItemModel(listItem, getters) {
        var _this = _super.call(this, getters) || this;
        _this.id = listItem.id;
        _this.listId = listItem.listByListId || listItem.listId;
        _this.questionId = listItem.questionByQuestionId || listItem.questionId;
        _this.articleId = listItem.articleByArticleId || listItem.articleId;
        _this.videoId = listItem.videoByVideoId || listItem.videoId;
        _this.listId = listItem.listByListId || listItem.listId;
        _this.position = listItem.position;
        _this.distinctUserReplies = listItem.distinctUserReplies;
        _this.averageScore = listItem.averageScore;
        return _this;
    }
    Object.defineProperty(ListItemModel.prototype, "progresses", {
        get: function () {
            return this.getters.progressesByListItemId(this.id);
        },
        enumerable: true,
        configurable: true
    });
    ListItemModel.prototype.getVideoOrArticleProgress = function () {
        if (this.progresses && this.progresses.length > 0)
            return 100;
        else
            return 0;
    };
    ListItemModel.prototype.getQuestionProgress = function () {
        if (this.isObjective()) {
            if (this.question.answered)
                return 100;
        }
        if (this.isDiscursive() || this.isPractice()) {
            if (this.question.currentUserComments.length > 0)
                return 100;
        }
        return 0;
    };
    Object.defineProperty(ListItemModel.prototype, "progress", {
        get: function () {
            if (this.isVideo() || this.isArticle()) {
                return this.getVideoOrArticleProgress();
            }
            if (this.isQuestion()) {
                return this.getQuestionProgress();
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListItemModel.prototype, "behavior", {
        get: function () {
            if (this.isArticle())
                return 'article';
            if (this.isVideo())
                return 'video';
            if (this.isObjective())
                return 'question';
            if (this.isDiscursive())
                return 'trivia';
            if (this.isPractice())
                return 'practice';
            return;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListItemModel.prototype, "label", {
        get: function () {
            if (this.isObjective())
                return /* i18n.t('exercise') */ 'Exercício';
            if (this.isDiscursive())
                return /* i18n.t('trivia') */ 'Pensar e Responder';
            if (this.isPractice()) {
                return /* i18n.t('practice') */ 'Atividade Prática';
            }
            if (this.isArticle()) {
                if (this.article)
                    return this.article.title;
                return 'Explicação';
            }
            if (this.isVideo()) {
                if (this.video)
                    return this.video.name;
                return 'Aula';
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListItemModel.prototype, "description", {
        get: function () {
            if (this.isObjective()) {
                return this.quantity
                    ? this.quantity + " " + 'questões'
                    : '';
            }
            if (this.isDiscursive())
                return "1 " + 'questões';
            if (this.isPractice()) {
                return "1 " + 'questões';
            }
            if (this.isArticle()) {
                var wordsPerMinute = 250;
                var totalWords = this.article.contents.reduce(function (acc, content) {
                    // Just to avoid html tags
                    var div = document.createElement('div');
                    div.innerHTML = content.isText() ? content.text.body : '';
                    var text = div.textContent || div.innerText || '';
                    return acc + text.split(' ').length;
                }, 0);
                var readingMinutes = totalWords / wordsPerMinute;
                return readingMinutes.toFixed() + " " + 'minutos de leitura';
            }
            if (this.isVideo()) {
                if (!this.video || !this.video.duration)
                    return '-';
                var videoMinutes = Math.trunc(this.video.duration / 60);
                var videoSeconds = this.video.duration % 60;
                var videoMinutesFormatted = videoMinutes.toString().padStart(2, '0');
                var videoSecondsFormatted = videoSeconds.toString().padStart(2, '0');
                return videoMinutesFormatted + ":" + videoSecondsFormatted;
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListItemModel.prototype, "article", {
        get: function () {
            return this.getters.articleById(this.articleId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListItemModel.prototype, "question", {
        get: function () {
            return this.getters.questionById(this.questionId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListItemModel.prototype, "video", {
        get: function () {
            return this.getters.videoById(this.videoId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListItemModel.prototype, "trivia", {
        get: function () {
            // just to work with content get.
            return this.question;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListItemModel.prototype, "practice", {
        get: function () {
            return this.question;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListItemModel.prototype, "list", {
        get: function () {
            return this.getters.listById(this.listId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListItemModel.prototype, "content", {
        get: function () {
            // this[this.behavior] is wrong because there is no video, trivia and question methods,
            // so the ts is complaining. In the future, we'll have those methods and this ignore
            // could be removed.
            // return this.behavior && this[this.behavior];
            // TODO Refactor this maybe
            if (this.behavior === 'article')
                return this.article;
            else if (this.behavior === 'video')
                return this.video;
            else if (this.behavior === 'question')
                return this.question;
            else if (this.behavior === 'trivia')
                return this.trivia;
            else if (this.behavior === 'practice')
                return this.practice;
        },
        enumerable: true,
        configurable: true
    });
    ListItemModel.prototype.isArticle = function () {
        return !!this.articleId;
    };
    ListItemModel.prototype.isVideo = function () {
        return !!this.videoId;
    };
    ListItemModel.prototype.isQuestion = function () {
        return !!this.questionId;
    };
    ListItemModel.prototype.isObjective = function () {
        if (!this.isQuestion())
            return false;
        return !!this.question.isObjective();
    };
    ListItemModel.prototype.isDiscursive = function () {
        if (!this.isQuestion())
            return false;
        return !!this.question.isDiscursive();
    };
    ListItemModel.prototype.isPractice = function () {
        if (!this.isQuestion())
            return false;
        return !!this.question.isPractice();
    };
    ListItemModel.prototype.isCompleted = function () {
        return this.progress === 100;
    };
    return ListItemModel;
}(Model_1.default));
exports.ListItemModel = ListItemModel;
